import { Component, HostListener } from '@angular/core';
import { RouterOutlet, Router } from '@angular/router';
import { LoaderComponent } from './loader/loader/loader.component';
import { InactivitylockscreenService } from './services/inactivitylockscreen.service';
import { ScriptLoaderService } from './services/script-loader.service';
import { FooterComponent } from './pages/footer/footer.component';
import { CommonserviceService } from './services/commonservice.service';
import { NetworkService } from './services/network.service';
import { TabSessionService } from './services/tab-session.service';
import { ScreenIdleStatusCheckService } from './services/screen-idle-status-check.service';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoaderComponent, FooterComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {

  constructor(private inactivityService: InactivitylockscreenService, private scriptLoader: ScriptLoaderService, private globalService: CommonserviceService, private router: Router, private networkService: NetworkService, private tabSessionService: TabSessionService, private idleService: ScreenIdleStatusCheckService) {


  }
  ngOnInit() {
    this.idleService.startWatching();
    this.inactivityService.initInactivityTimer();
    this.getVersionUpdatecheck();
    this.networkService.initNetworkListener();
  }

  async getVersionUpdatecheck(): Promise<void> {
    this.globalService.getVersionCodeforApp().subscribe({
      next: async (data: any) => {
        try {
          if (data?.status !== 'SUCCESS' || data?.code !== 200) {
            return;
          }

          const { isDownTIme, dwnTimeEnd, pgLink } = data?.data?.[0] || {};

          if (pgLink) {
            await this.loadScript(pgLink);
          }

          if (isDownTIme) {
            sessionStorage.setItem('isEndDownTime', dwnTimeEnd);
            this.router.navigate(['/vpartner-maintenance']);
          }

        } catch (error) {
          console.error('Version script loading failed:', error);
        }
      },

      error: (err) => {
        console.error('Version check failed:', err);
      }
    });
  }

  loadScript(url: string): Promise<void> {
    return new Promise((resolve, reject) => {

      if (!url) {
        reject(new Error('Script URL is empty'));
        return;
      }

      // Check if script is already added
      const existingScript = document.querySelector(
        `script[src="${url}"]`
      ) as HTMLScriptElement | null;

      if (existingScript) {

        // Already loaded
        if (existingScript.dataset.loaded === 'true') {
          resolve();
          return;
        }

        // Still loading
        existingScript.addEventListener('load', () => resolve(), {
          once: true
        });

        existingScript.addEventListener('error', () => {
          reject(new Error(`Failed to load script: ${url}`));
        }, {
          once: true
        });

        return;
      }

      // Create script
      const script = document.createElement('script');

      script.src = url;
      script.async = true;

      script.onload = () => {
        script.dataset.loaded = 'true';
        resolve();
      };

      script.onerror = () => {
        reject(new Error(`Failed to load script: ${url}`));
      };

      document.body.appendChild(script);
    });
  }

  ngAfterViewInit() {


  }



}
